module.exports = __webpack_public_path__ + "static/media/empty_tasks.4bb6817b.png";